/**
 * Here is a two separated parts of original script with purposes:
 * - to setup analytical object for faster access
 * - to load a script
 *
 * Setup tiktok object but not load the script
 */
export const setup = () => {
  /* eslint-disable */
  const w = window;
  const t = 'ttq';

  w.TiktokAnalyticsObject = t;
  const ttq = (w[t] = w[t] || []);
  ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
  ];
  ttq.setAndDefer = function (t, e) {
    t[e] = function () {
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
  ttq.instance = function (t) {
    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
    return e;
  };
  /* eslint-enable */
};

/**
 * Load a script
 */
export const load = (config, onLoad, onError) => {
  const t = 'ttq';
  /* eslint-disable */
  window.ttq.load = function (e, n) {
    const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
    (ttq._i = ttq._i || {}),
      (ttq._i[e] = []),
      (ttq._i[e]._u = i),
      (ttq._t = ttq._t || {}),
      (ttq._t[e] = +new Date()),
      (ttq._o = ttq._o || {}),
      (ttq._o[e] = n || {});
    const o = document.createElement('script');
    o.type = 'text/javascript';
    o.async = !0;
    o.src = i + '?sdkid=' + e + '&lib=' + t;
    if (onLoad) {
      o.onload = o.onreadystatechange = onLoad;
      o.onabort = onError || onLoad;
      o.onerror = onError || onLoad;
    }
    const a = document.getElementsByTagName('script')[0];
    a.parentNode.insertBefore(o, a);
  };
  /* eslint-enable */

  window.ttq.load(config.id);
  // Tiktok send their 'Pageview' event only on script initialization,
  // only once, so it's not optimized for SPA.
  // Move to analytics if needed.
  window.ttq.page();
};

/**
 * Some property of loaded script for bulletproof checking
 */
export const isInitialized = (options, waitInterval = 30) => {
  return new Promise(resolve => {
    (function wait() {
      if (window[window.TiktokAnalyticsObject]?.initialize === true) {
        resolve();
      } else {
        setTimeout(() => {
          wait();
        }, waitInterval);
      }
    })();
  });
};
